import SubsectionFooter from "./SubsectionFooter";

export default SubsectionFooter;
export { SubsectionFooter };
